import type { Environment } from './environment.d';

export const environment: Environment = {
  type: 'development',
  production: false,
  alpha: true,
  apiURL: 'http://localhost:3333/api',
  UNVOID_API_KEY: '09aba92f-ac31-4fed-bfd3-eb283d1c86c6',
};
